module.exports = __webpack_public_path__ + "static/media/dornan.dbe9c572.png";